export default __webpack_public_path__ + "static/media/logo.bc059d0a.png";